export default "__VITE_ASSET__BAGZVg$C__"